export const getIsEmptyValue = (values: string) => {
  const updatedValue = values.replaceAll("\n", "");

  return Boolean(updatedValue);
};
